<script setup lang="ts">
import type { PropertySearchCriteria } from '@@/shared/property/search-criteria';
import { useInputRangeErrors } from '~/composables/errors';

withDefaults(
  defineProps<{
    variant?: `popover` | `dialog`
  }>(),
  {
    variant: `popover`,
  });

const modelValue = defineModel<PropertySearchCriteria>({ required: true });

const surfaceMin = toRef(() => modelValue.value.surfaceMin);
const surfaceMax = toRef(() => modelValue.value.surfaceMax);
const { focusedInput, errors } = useInputRangeErrors(surfaceMin, surfaceMax);

// Need to spread the v-model to pass the emitted(update:modelValue) test correctly
function updateSurfaceMin(surfaceMin?: number) {
  modelValue.value = {
    ...modelValue.value,
    surfaceMin,
  };
};

// Need to spread the v-model to pass the emitted(update:modelValue) test correctly
function updateSurfaceMax(surfaceMax?: number) {
  modelValue.value = {
    ...modelValue.value,
    surfaceMax,
  };
};
</script>

<template>
  <div class="grid grid-cols-2 gap-xs">
    <IadInputNumber
      v-model="modelValue.surfaceMin"
      name="surfaceMin"
      :label="$t('property_serp.filters.min')"
      variant="surface"
      autocomplete="off"
      clearable
      :error="errors.min"
      @focus="focusedInput = 'min'"
      @update:model-value="updateSurfaceMin"
    />
    <IadInputNumber
      v-model="modelValue.surfaceMax"
      name="surfaceMax"
      :label="$t('property_serp.filters.max')"
      variant="surface"
      autocomplete="off"
      clearable
      :error="errors.max"
      @focus="focusedInput = 'max'"
      @update:model-value="updateSurfaceMax"
    />
  </div>
</template>
